import { Component } from '@angular/core';
import { CandidateService } from 'src/app/services/candidate.service';
import { LoaderServiceService } from 'src/app/services/loader-service.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  
  tncData:any = {}
    constructor(
      private candidateService:CandidateService,
      private loaderService: LoaderServiceService,
  
    ){
      this.scrollToTop()
    }
    scrollToTop() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  
    ngOnInit(){
      this.getPolicyByName('privacy_policy');
    }
    getPolicyByName(name:any) {
          this.loaderService.show();

      let reqObj = {
        name:name,
      };
      this.candidateService.getPolicyByName(reqObj).subscribe((response: any) => {
        if (response.statusCode == 200) {
              this.loaderService.hide();

          // this.blogList=response.data
          this.tncData=response.data
         
        }
      });
    }
}
